import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var compressImage = normalize.compressImage(function (args) {
  if (isDingdingMiniapp) {
    args.filePaths = [args.src];
  } else {
    args.apFilePaths = [args.src];
  }

  args && typeof args.quality === 'number' && (args.compressLevel = args.quality);
  return isDingdingMiniapp ? dd.compressImage(args) : my.compressImage(args);
}, CONTAINER_NAME.ALIPAY);
export default compressImage;